import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  '.MuiTab-root': {
    textTransform: 'capitalize !important'
  },
  ticketsPanel: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    padding: '8px'
  },
  ticketsWrapper: {
    position: 'relative',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    overflow: 'hidden',
    border: 'none',
    borderRadius: '8px'
  },
  ticketsBoxWrapper: {
    overflowY: 'scroll',
    overflowX: 'hidden',
    ...theme.scrollbarStyles,
    [theme.breakpoints.down('sm')]: {
      // Altura do BottomNavbar + um pouco de respiro
      paddingBottom: '90px',
      height: 'calc(100vh - 140px)' // Ajuste conforme a altura do seu Header Azul
    }
  },

  tabsHeader: {
    flex: 'none'
    // backgroundColor: "#eee",
  },

  settingsIcon: {
    alignSelf: 'center',
    marginLeft: 'auto',
    padding: 8
  },

  tabWithGroups: {
    minWidth: 90,
    width: 90
  },

  tab: {
    minHeight: '95px !important',
    padding: '0px 4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& span': {
      gap: '2px',
      textTransform: 'none',
      fontWeight: '600',
      fontSize: '.7rem',
      display: 'flex',
      flexDirection: 'column'
    },
    '& button': {
      minWidth: 50,
      width: 50,
      '& span svg': {
        width: '22px',
        height: '22px',
        margin: '5px 0'
      },
      '& .MuiTab-wrapper ': {
        width: '30%'
      }
    },
    [theme.breakpoints.up('lg')]: {
      // minHeight: '95px !important',
      '& span': {
        fontSize: '.875rem'
      }
    }
  },

  tabMobile: {
    minHeight: '75px !important',
    padding: '4px',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '& span': {
      gap: '2px',
      textTransform: 'none',
      fontWeight: '600',
      fontSize: '.875rem',
      display: 'flex',
      flexDirection: 'column'
    },
    '& button': {
      minWidth: 50,
      width: 50,
      '& span svg': {
        width: '22px',
        height: '22px',
        margin: '5px 0'
      },
      '& .MuiTab-wrapper ': {
        width: '30%',
        marginTop: '4px'
      }
    },
    [theme.breakpoints.down('sm')]: {
      '& button': {
        '& span svg': {
          width: '26px !important',
          height: '26px !important',
          margin: '0 !important'
        }
      }
    }
  },

  ticketOptionsBox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    // background: "#fafafa",
    padding: theme.spacing(1)
  },
  ticketsTabHeader: {
    padding: '12px 10px 0 10px',
    display: 'flex',
    gap: '10px'
    // [theme.breakpoints.up('lg')]: {
    //   padding: '10px 10px 0 10px',
    //   gap: '20px'
    // }
  },

  filterActive: {
    padding: '5px 10px',
    display: 'flex',
    gap: '8px'
  },
  filterChip: {
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    fontSize: '10px',
    fontWeight: '500',
    textTransform: 'uppercase',
    borderRadius: '4px',
    height: '18px',
    '&:hover': {
      backgroundColor: theme.palette.blue_300.main,
      color: theme.palette.white_100.main
    },
    '& svg': {
      color: theme.palette.white_100.main,
      marginLeft: '2px',
      width: '14px',
      height: '14px'
    },
    '& .MuiChip-label': {
      padding: '0 6px'
    }
  },

  searchInputWrapper: {
    flex: 1,
    background:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 8,
    padding: '4px 12px',
    height: '31px',
    border:
      theme.palette.type === 'dark'
        ? '1px solid' + theme.palette.dark_stroke.main
        : '1px solid' + theme.palette.gray_stroke.main,
    '&:focus-within': {
      outline: '2px solid' + theme.palette.blue_300.main
    },
    '& .MuiInputBase-root': {
      flex: 1
    },
    // [theme.breakpoints.up('lg')]: {
    //   height: '43px'
    // },
    [theme.breakpoints.down('sm')]: {
      // height: '43px',
      marginTop: '5px',
      '&:focus-within': {
        outline: 'none'
      }
    }
  },
  searchIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    // marginLeft: 6,
    marginRight: 6,
    alignSelf: 'center'
  },

  searchInput: {
    '& input': {
      flex: 1,
      border: 'none',
      borderRadius: 30
    }
  },

  closedButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    padding: '5px 20px 0'
  },

  actionButtonIcons: {
    padding: '6px !important',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor: 'transparent',
    '&:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main
    },
    '& .MuiIconButton-root': {
      padding: '8px !important'
    }
  },
  actionButtonRefresh: {
    width: '35px', // Defina um tamanho fixo
    height: '35px', // Mesmo valor da largura
    borderRadius: '50%', // Garante o formato circular
    padding: '0 !important',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    backgroundColor: 'transparent',
    '&:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor: 'transparent'
    }
  },
  actionButtonNewTicket: {
    backgroundColor: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    width: '35px', // Defina um tamanho fixo
    height: '35px', // Mesmo valor da largura
    borderRadius: '50%', // Garante o formato circular
    padding: '0 !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: theme.palette.blue_400.main,
      color: theme.palette.white_100.main
    }
  },

  show: {
    display: 'block'
  },
  hide: {
    display: 'none !important'
  },

  icon24: {
    width: 24,
    height: 24
  },
  badge: {
    right: '-10px',
    '& span': {
      color:
        theme.palette.type === 'dark'
          ? theme.palette.white_100.main
          : theme.palette.gray_400.main
    }
  },

 customGreenBadge: {
    backgroundColor: theme.palette.green_200.main, // Cor verde personalizada (ex: Verde Material Design)
    color: theme.palette.white_100.main,
    top: '5px'
  },
}))
